import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { useCall } from '../../hooks/useCall';
import { ContactsPopup, ICallContact } from '../../components/ContactsPopup';
import { useSelector } from 'react-redux';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';

export interface IOfferContactsPopupContainerProps {
  offerId: number;
  isOpen: boolean;
  onClose(): void;
}

export function ContactsPopupContainer({ offerId, onClose, isOpen }: IOfferContactsPopupContainerProps) {
  const offer = useSelector(selectRecommendationById(offerId));

  const { author } = offer;
  const [isPhoneVisible, setIsPhoneVisible] = React.useState(false);
  const [comagicPhone, setComagicPhone] = React.useState<string | null>(null);

  const { loadComagicPhone, produceCall, phone: authorPhone, isLeadFactory } = useCall(offer);

  const phone = comagicPhone || authorPhone;

  React.useEffect(() => {
    async function load() {
      setIsPhoneVisible(false);
      const comagicPhone = await loadComagicPhone();

      setComagicPhone(comagicPhone);
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone]);

  const onPhoneClick = React.useCallback(() => {
    if (!isPhoneVisible) {
      setIsPhoneVisible(true);
    } else {
      produceCall(phone || '');
    }
  }, [isPhoneVisible, phone, produceCall]);

  const contact: ICallContact = {
    avatar: author?.avatar,
    displayName: author?.displayName,
    description: isLeadFactory ? 'Консультант' : author?.fromDeveloper,
  };

  if (!phone) {
    return null;
  }

  return (
    <ModalWindow
      content={
        <ContactsPopup isPhoneVisible={isPhoneVisible} phone={phone} contact={contact} onPhoneClick={onPhoneClick} />
      }
      open={isOpen}
      onClose={onClose}
      fixed
    />
  );
}
